const Responsive = {
    desktop: "@media (min-width: 1651px) and (max-width: 9999px)",
    laptop: "@media (min-width: 1200px) and (max-width: 1650px)",
    tablet: "@media (min-width: 768px) and (max-width: 1199px)",
    mobile: "@media (max-width: 767px)",
};

export default Responsive;